// Event handler for Schedule Central
import { EventBus } from "@/EventBus.js";
import moment from 'moment';


export function openOverlapScheduleErrors( { schedule, overlappingSchedules, student, teacher } ) {
    const title = 'Error: Overlapping Schedules';
    const mode = "OverlappingSchedules";
    const data = {
        value: overlappingSchedules,
        schedule,
        student,
        teacher
    };
    EventBus.$emit('open-dialog', title, mode, data);
}

export function openClosureSchedule() {
    const title = 'Holiday & Closure Schedule';
    const mode = "HolidayClosureSchedule";
    const data = {};

    EventBus.$emit('open-dialog', title, mode, data);
}

export function openSchedulingActivities() {
    const title = 'Schedule Activities';
    const mode = "SchedulingActivities";
    const data = {};

    EventBus.$emit('open-dialog', title, mode, data);
}

export function openAttendance() {
    const title = 'Student Attendance';
    const mode = "StudentAttendance";
    const data = {};

    EventBus.$emit('open-dialog', title, mode, data);
}

export function openEditTeacherScheduleInstance({ teacherSchedule, parentID  }) {

    const title = 'Edit Teacher Schedule';
    const data = {
        teacherSchedule
    };
    const mode = "EditTeacherSchedule";

    EventBus.$emit('open-dialog', title, mode, data, parentID );
}

export function openNewTeacherSchedule({ teacher, classroom, startDate = moment() }) {

    const title = "New Teacher Schedule";
    const mode = "NewTeacherSchedule";

    const data = {
        selectedDate: startDate.format("YYYY-MM-DD"),
        startTime: startDate.format("HH:mm"),
        selectedTeacher: teacher,
        selectedClassroom: classroom
    };

    EventBus.$emit('open-dialog', title, mode, data);
}

export function openNewTeacherAvailability({ teacher, startDate = moment() }) {

    const title = "New Teacher Availability";
    const mode = "NewTeacherAvailability";

    const data = {
        selectedDate: startDate.format("YYYY-MM-DD"),
        startTime: startDate.format("HH:mm"),
        selectedTeacher: teacher
    };

    EventBus.$emit('open-dialog', title, mode, data);
}



export function openEditStudentScheduleInstance({ studentSchedule, teacher, parentID }) {

    const title = 'Edit student schedule';
    const data = {
        studentSchedule,
        teacher
    };
    const mode = "EditStudentSchedule";

    EventBus.$emit('open-dialog', title, mode, data, parentID);
}



export function openNewStudentSchedule({ student, teacher, classroom, startDate, endDate, startTime, endTime, recurring, recurringEndDate, recurringDays, parentID }) {

    const title = "New Student Schedule";
    const mode = "NewStudentSchedule";

    const data = {
        selectedDate: startDate,
        startTime: startTime,
        selectedTeacher: teacher,
        selectedClassroom: classroom,
        defaultStudent: student,
        endDate,
        endTime,
        recurring,
        recurringEndDate,
        recurringDays,
    };

    EventBus.$emit('open-dialog', title, mode, data, parentID);
}


export function openStudentAttendance({ student, programIds = [] }) {
    const title = "Student Attendance Records";
    const mode = "SingleStudentAttendanceView";
    const data = {
        value: student,
        programIds: programIds
    };

    EventBus.$emit('open-dialog', title, mode, data);
}


export function openStudentScheduleLookup({ student = null }) {
    const title = "Student Schedule Lookup";
    const mode = "StudentScheduleLookup";
    const data = {
        value: student
    };
    EventBus.$emit('open-dialog', title, mode, data);
}

export function openTeacherScheduleLookup({ teacher = null }) {
    const title = "Teacher Schedule Lookup";
    const mode = "TeacherScheduleLookup";
    const data = {
        value: teacher
    };

    EventBus.$emit('open-dialog', title, mode, data);
}


export function handleEditStudentScheduleItem(item, classrooms) {
    let dialogTitle, dialogData, dialogMode;


    dialogTitle = 'Edit student schedule';
    dialogData = {
        studentSchedule: item.data,
        classrooms
    };
    dialogMode = "EditStudentSchedule";


    return { dialogTitle, dialogData, dialogMode };
}

// function handleEditTeacherScheduleItem(item, classrooms, row = null, allItems = []) {
//     let dialogTitle, dialogData, dialogMode;

//     let studentSchedules = [];
//     if (row.groupType == 'teacher') {
//         const teacherId = row.entityId;
//         studentSchedules = allItems.filter(item => item.type == 'student-schedule' && item.teacherId == teacherId);
//     }
//     else if (row.groupType == 'classroom') {
//         const classroomId = row.entityId;
//         studentSchedules = allItems.filter(item => item.type == 'student-schedule' && item.classroomId == classroomId);
//     }

//     // filter out student schedule overlapping with teacher's schedule start and end time
//     if (studentSchedules && studentSchedules.length > 0) {
//         // Convert teacher's schedule to Moment objects
//         const teacherStartTime = moment(item.startTime, 'HH:mm');
//         const teacherEndTime = moment(item.endTime, 'HH:mm');

//         studentSchedules = studentSchedules.filter(ss => {
//             // Make copies of start and end so we don't modify the original objects
//             let ssStart = ss.time.start.clone();
//             let ssEnd = ss.time.end.clone();

//             // Strip the date parts so we're left with today's date and the original time
//             ssStart.year(teacherStartTime.year()).month(teacherStartTime.month()).date(teacherStartTime.date());
//             ssEnd.year(teacherEndTime.year()).month(teacherEndTime.month()).date(teacherEndTime.date());

//             // Now we can compare just the time parts
//             return !(
//                 teacherStartTime.isBefore(ssEnd) &&
//                 teacherEndTime.isAfter(ssStart)
//             );
//         });

//     }

//     dialogTitle = 'Edit Teacher Schedule';
//     dialogData = {
//         teacherSchedule: item.data,
//         classrooms,
//         studentSchedules
//     };
//     dialogMode = "EditTeacherSchedule";


//     return { dialogTitle, dialogData, dialogMode };
// }

function handleStudentScheduleItem(item, row) {
    let title, data, mode;
    const date = moment(item.time.start).format("YYYY-MM-DD");
    const unassigned = !item.teacherId && !item.classroomId;

    if (item.teacherId || item.classroomId) {
        const groupName = item.teacherId ? item.teacherName : item.classroomName;

        title = unassigned ? 'Unassigned Students' : `${groupName}'s Students`;
        data = {
            item,
            row
        };
        mode = "ViewStudentsSchedules";
    } else {
        title = `Assign Teachers`;
        data = {
            studentSchedules: item.details,
            date
        };
        mode = "TeacherAssignment";
    }

    EventBus.$emit('open-dialog', title, mode, data);
}

function handleAvailabilityItem(item, row) {
    const selectedDate = moment(item.time.start).format("YYYY-MM-DD");
    const startTime = moment(item.time.start).format("HH:mm");
    const endTime = moment(item.time.end).format("HH:mm");

    const selectedTeacher = {
        id: row.entityId,
        name: row.name,
    };

    const dialogData = {
        mode: "schedule",
        selectedDate,
        startTime,
        endTime,
        selectedTeacher,
    };

    const dialogMode = "NewTeacherAvailability";

    return { dialogData, dialogMode };
}

function handleTeacherScheduleItem(item, row) {

    const title = 'View Teacher Schdules'
    const data = {
        item,
        row,
    };

    const mode = "ViewTeachersSchedules";

    EventBus.$emit('open-dialog', title, mode, data);
}

// function handleDefaultItem(item) {
//     const selectedDate = moment(item.time.start).format("YYYY-MM-DD");

//     const dialogMode = "debug";
//     const dialogTitle = `${item.teacherName}'s ${item.type} - ${selectedDate}`;
//     const dialogData = JSON.stringify(item, null, 2); // Beautify the JSON output

//     return { dialogTitle, dialogData, dialogMode };
// }

// function handleEmailTeacherSchedule(row, dateRange) {
//     const dialogTitle = "Email Teacher Schedule";
//     const dialogMode = "EmailTeacherSchedules";
//     const dialogData = {
//         dateRange,
//         row
//     };

//     return { dialogTitle, dialogData, dialogMode };
// }


/* eslint-disable no-unused-vars */
export function handleItem(event, item, row) {
    switch (event) {
        case "student-schedule":
            return handleStudentScheduleItem(item, row);
        case "availability":
            return handleAvailabilityItem(item, row);
        case "schedule":
            return handleTeacherScheduleItem(item, row);
    }
}

/* eslint-disable no-unused-vars */
export function handleCell(row, selectedDate) {
    const classroom =
        row && row.groupType == "classroom" && row.entityId
            ? row.entityId
            : null;
    const teacher =
        row && row.groupType == "teacher" && row.entityId
            ? {
                id: row.entityId,
                name: row.name,
                firstName: row.teacherFirstName,
                lastName: row.teacherLastName,
            }
            : null;
    switch (row.type) {
        case "student-schedule":
            openNewStudentSchedule({
                classroom,
                teacher,
                startDate: selectedDate,
            });
            break;
        case "schedule":
            openNewTeacherSchedule({
                classroom,
                teacher,
                startDate: selectedDate,
            });
            break;
        case "teacher-availability":
            openNewTeacherAvailability({
                teacher,
                startDate: selectedDate,
            });
            break;
    }
}

